import { type ApiClient } from "@anna-money/anna-web-lib/api";
import { ComplianceCallData } from "./complianceCallTypes";

const COMPLIANCE_CALL_URL = "api/formations/v2/compliance/call";

export interface IComplianceCallClient {
  // Starts a compliance call. company_id is taken from the auth token.
  requestCall: () => Promise<ComplianceCallData>;
  // Reads the current compliance-call state (initial form state + polling).
  getCallState: () => Promise<ComplianceCallData>;
}

// Real client — wired in services.ts.
export class ComplianceCallClient implements IComplianceCallClient {
  private readonly _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  async requestCall(): Promise<ComplianceCallData> {
    const response = await this._apiClient.post(COMPLIANCE_CALL_URL, {});
    return response.getData(ComplianceCallData);
  }

  async getCallState(): Promise<ComplianceCallData> {
    const response = await this._apiClient.get(COMPLIANCE_CALL_URL);
    return response.getData(ComplianceCallData);
  }
}
